import { usePublicShop } from "@babackapp/return-widget-components/queries/use-public-shop";
import { useSetReturnMode } from "@babackapp/return-widget-components/hooks/use-set-return-mode";
import { useWidgetParams } from "@babackapp/return-widget-components/hooks/use-widget-params";
import type { ReturnMode } from "@babackapp/return-widget-components/types";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

type ReturnModeFormValues = {
  returnMode: ReturnMode;
  pickupDate?: string;
  storeId?: string;
};

export function useReturnModeForm() {
  const navigate = useNavigate();
  const { shopId, orderId } = useWidgetParams();
  const { data: shop } = usePublicShop(shopId);
  const setReturnMode = useSetReturnMode(orderId);

  const form = useForm<ReturnModeFormValues>({
    defaultValues: {
      returnMode: "carrier",
      pickupDate: undefined,
      storeId: undefined,
    },
  });

  const availableReturnModes: ReturnMode[] = ["carrier"];

  const hasStoreReturns = shop.returnToStore?.activated === true;
  if (hasStoreReturns) {
    availableReturnModes.push("store");
  }

  const selectableStores = (shop.returnToStore?.stores || []).filter(
    (store) => store.selectableByUser,
  );

  const onSubmit = form.handleSubmit(async (values) => {
    setReturnMode(
      values.returnMode,
      values.returnMode === "store" ? (values.storeId ?? null) : null,
      values.returnMode === "carrier" ? (values.pickupDate ?? null) : null,
    );
    navigate("../address");
  });

  return {
    form,
    onSubmit,
    availableReturnModes,
    selectableStores,
    hasStoreReturns,
  };
}
